<template>
  <main-input-dialog
    :is-visible.sync="computedIsVisible"
    :title-translation="$i18n.t('dialog.title.sendMessage')"
    agree-text="dialog.agreeSend"
    :inputs="inputs"
    :loading="isLoading"
    :reset-on-close="false"
    body-height="50vh"
    dialog-width="30%"
    @agree="messageSendHandler"
  >
    <template v-for="input of inputs" #[`${input.name}.input`]="data">
      <v-col :key="input.name" cols="6">
        <data-input v-model="payload[input.name]" v-bind="data" />
      </v-col>
    </template>
  </main-input-dialog>
</template>

<script>
import { get, call } from 'vuex-pathify';

import DataInput from '@/components/DataInput';

export default {
  name: 'SendMessageDialog',
  components: {
    DataInput,
    MainInputDialog: () => import('@/components/MainInputDialog'),
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    selectedFeatures: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    isLoading: false,
    payload: {
      protocol: 'E-mail',
      attribute: undefined,
      subject: undefined,
      content: undefined,
    },
  }),
  computed: {
    currentLayer: get('layers/currentLayer'),
    currentLayerDataSource: get('layers/currentLayer@data_source_name'),
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.payload = {
          protocol: 'E-mail',
          attribute: undefined,
          subject: undefined,
          content: undefined,
        };
        this.$emit('update:isVisible', nV);
      },
    },
    layerAttributes() {
      return this.$_flattenStructure(this.currentLayer.form_schema.elements).map(attr => {
        return {
          text: attr.label,
          value: attr.attribute,
        };
      });
    },
    isEmailProtocol() {
      return this.payload.protocol === 'E-mail';
    },
    inputs() {
      const inputs = [
        {
          name: 'protocol',
          translationPath: 'dialog.messageProtocol',
          dataType: { name: 'select' },
          items: ['E-mail', 'SMS'],
        },
        {
          name: 'attribute',
          translationPath: this.isEmailProtocol ? 'dialog.emailAttribute' : 'dialog.phoneAttribute',
          dataType: { name: 'select' },
          items: this.layerAttributes,
          itemText: 'text',
          itemValue: 'value',
        },
        ...(this.isEmailProtocol
          ? [
              {
                name: 'subject',
                translationPath: 'dialog.emailSubject',
                dataType: { name: 'text' },
              },
            ]
          : []),
        {
          name: 'content',
          translationPath: this.isEmailProtocol ? 'dialog.messageEmailText' : 'dialog.messageSmsText',
          dataType: { name: 'textarea' },
          autoGrow: true,
          dense: true,
          rows: '4',
        },
      ];
      return inputs.map(input => {
        return {
          ...input,
          cols: 12,
          leftCol: 5,
          rightCol: 6,
          spacer: true,
          rules: [v => !!v || v == '0' || 'rules.required'],
        };
      });
    },
  },
  methods: {
    sendMessage: call('externalSystems/sendMessage'),
    async messageSendHandler() {
      this.isLoading = true;
      let { protocol, ...params } = this.payload;
      if (this.isEmailProtocol) {
        protocol = 'email';
      } else {
        protocol = 'sms';
        params.subject = undefined;
      }
      const payload = {
        protocol,
        body: {
          ...params,
          datasource: this.currentLayerDataSource,
          ids: this.selectedFeatures,
        },
      };
      try {
        await this.sendMessage(payload);
        this.$store.set('snackbar/PUSH_SUCCESSFULLY_MESSAGE!', {
          message: this.$i18n.t('success.messageWasSent'),
        });
      } catch (error) {
        console.log('  error', error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
